import { PatientAllMessagesPage } from "./patientAllMessages";

export const PatientAllMessages = PatientAllMessagesPage;
